import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import ApiService from './apiService';
import type { ltCommon, ltFramework } from '@life-time-inc/enterprise-framework-core';
import { featureFlagService } from '@life-time-inc/enterprise-framework-core';

const MESSAGING_CLUB_NOTIFICATIONS_API_FEATURE_ID = 'messagingClubNotificationsAPIEnabled';

const getBaseUrl = () => {
	return featureFlagService.isEnabled(MESSAGING_CLUB_NOTIFICATIONS_API_FEATURE_ID)
		? '/messaging/club-notifications/v1'
		: '/aem/club-notifications/v1';
};

export const ClubNotificationServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.ltApiUrl + getBaseUrl(),
	headers: {
		'Content-Type': 'application/json; charset=UTF-8',
		'apiKey': window.lt.api.apimKey
	}
});

class ClubNotificationService extends ApiService implements ltFramework.IClubNotificationService {
	constructor() {
		super('club-notification-service', ClubNotificationServiceAxiosInstance);
	}

	public getClubNotifications(id: number): AxiosPromise<ltFramework.IAlertNotification[]> {
		const config: ltCommon.IAxiosRequestConfig = {
			useJwt: true,
			params: {
				clubId: id
			}
		};
		return this.axiosInstance.get('/club', config);
	}
}

export const clubNotificationService = new ClubNotificationService();
